var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResourceDetail',{attrs:{"resource-override":_vm.AUTH_CONFIG,"flex-content":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }